
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","viewBox":"0 0 374.57 357.12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M374.13 135.75a9 9 0 00-7.27-6.13L248.32 112.4l-53-107.43a9 9 0 00-16.14 0l-53 107.39L7.7 129.62a9 9 0 00-5 15.35l85.75 83.59-20.24 118a9 9 0 0013 9.49l106-55.72 106 55.72a9 9 0 0013.11-9.46l-20.25-118 85.78-83.62a9 9 0 002.28-9.22z","fill":"#d9aa45"}})])
          )
        }
      }
    